module.exports = __webpack_public_path__ + "img/logo-columbia.914bc0c0.png";